// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1EntrySummarySchema = z.object({
  day: z.coerce.string().describe("Date in YYYY-MM-DD format"),
  entry_ids: z.array(z.number().int()).describe("List of entry IDs for this day"),
});
